/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/components/business-profiles-detail/business-profiles-detail.component.scss */
.panel-title {
  font-size: 14px;
  line-height: 12px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #7e7e7e;
  text-transform: uppercase;
  white-space: nowrap;
}
.business-profile-form {
  font-size: 14px;
  padding: 6px 16px 10px 16px;
  color: #394c5a;
}
.member-list {
  overflow: auto;
  max-height: calc(100vh - 26rem);
}
/*# sourceMappingURL=business-profiles-detail.component.css.map */
